<template>
    <div class="p-4 lg:w-full md:w-full">
        <table class="w-full table-auto border-collapse border border-gray-300">
            <thead>
                <tr class="bg-gray-200">
                    <th class="border border-gray-300 p-2">Nama Perusahaan</th>
                    <th class="border border-gray-300 p-2">NPWP Perusahaan</th>
                    <th class="border border-gray-300 p-2">Detail</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(each_penyedia, index) in list_penyedia" :key="index">
                    <td class="border border-gray-300 p-2">{{ each_penyedia.nama_perusahaan }}</td>
                    <td class="border border-gray-300 p-2">{{ each_penyedia.npwp_perusahaan }}</td>
                    <td class="border border-gray-300 p-2">
                        <Button label="Detail" icon="pi pi-info-circle" @click="showDetails(each_penyedia)" />
                    </td>
                </tr>
            </tbody>
        </table>
        <Dialog v-model:visible="dialogVisible" modal :style="{ width: '50vw' }" header="Detail Penyedia">
            <div class="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <strong>Nama Perusahaan:</strong>
                    <p>{{ selectedPenyedia.nama_perusahaan }}</p>
                </div>
                <div>
                    <strong>NPWP Perusahaan:</strong>
                    <p>{{ selectedPenyedia.npwp_perusahaan }}</p>
                </div>
                <div>
                    <strong>Nama Pemberi Kuasa:</strong>
                    <p>{{ selectedPenyedia.nama_pemberi_kuasa }}</p>
                </div>
                <div>
                    <strong>Nama Penerima Kuasa:</strong>
                    <p>{{ selectedPenyedia.nama_penerima_kuasa }}</p>
                </div>
                <div class="md:col-span-2">
                    <strong>Alamat Perusahaan:</strong>
                    <p>{{ selectedPenyedia.alamat_perusahaan }}</p>
                </div>
                <div class="md:col-span-2">
                    <strong>Alamat Perusahaan Semarang:</strong>
                    <p>{{ selectedPenyedia.alamat_perusahaan_semarang ? selectedPenyedia.alamat_perusahaan_semarang : '-' }}</p>
                </div>
                <div>
                    <strong>Status:</strong>
                    <p>{{ selectedPenyedia.status === '1' ? 'Aktif' : 'Tidak Aktif' }}</p>
                </div>
            </div>
        </Dialog>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import Button from "primevue/button";
import Dialog from "primevue/dialog";

export default defineComponent({
    components: {
        Button,
        Dialog,
    },
    data() {
        return {
            dialogVisible: false,
            selectedPenyedia: {},
        };
    },
    props: {
        list_penyedia: Array,
    },
    methods: {
        showDetails(penyedia) {
            this.selectedPenyedia = penyedia;
            this.dialogVisible = true;
        },
    },
});
</script>
